import { useMutation } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import successHandler from 'handlers/successHandler';
import errorHandler from 'handlers/errorHandler';
import { externalCommunityLogin } from 'api/apiRequest';
import CircularLoader from 'components/loader/CircularLoader';

export const MerchantLogin = () => {
	const location = useLocation();
	const navigate = useNavigate();

	const queryParams = new URLSearchParams(location.search);
	const interfaceToken = queryParams.get('interfaceToken');
	const advocateUserName = queryParams.get('advocateUserName');
	const email = queryParams.get('email');
	const userId = queryParams.get('userId');
	const countryCode = queryParams.get('countryCode');

	useEffect(() => {
		const userData = {
			interfaceToken: interfaceToken,
			advocateUserName: advocateUserName,
			email: email,
			userId: userId,
			countryCode: countryCode,
		};
		console.log('trying to do external login');
		mutate(userData);
	}, []);

	const { isLoading, mutate } = useMutation(externalCommunityLogin, {
		onError: (error: any) => {
			errorHandler(error, true);
		},
		onSuccess: (res: any) => {
			localStorage.setItem('game-user-token', res?.data?.accessToken);
			localStorage.setItem('game-user-secret', res?.data?.accessSecret);
			if (res?.data?.user) {
				localStorage.setItem('game-user-obj', JSON.stringify(res?.data?.user));
			}
			successHandler(res, true);
			navigate('/play');
		},
		retry: 0,
	});

	return (
		<>
			{isLoading ? (
				<div className="h-full  w-full flex items-center justify-center">
					<CircularLoader />
				</div>
			) : (
				<div className="h-full  w-full flex items-center justify-center">
					<CircularLoader />
				</div>
			)}
		</>
	);
};
